import {makeStyles} from '@material-ui/core';

const markdownFormatting = {
    marginBottom: '12px',
};

const markdownFormattingExtended = {
    ...markdownFormatting,
    '&:last-child': {
        marginBottom: '0',
    },
};

export const useStyles = makeStyles((useResume?: boolean) => ({
    // Main content card
    contentCard: {
        width: '100%',
        height: 'fit-content',
        backgroundColor: '#fff',
        borderRadius: '12px',
        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
        padding: useResume ? '28px 22px' : '32px',
        marginTop: '24px',
        '@media (max-width: 768px)': {
            padding: '16px',
            marginTop: '16px',
        },
        '& #fold-ai-assist-panel-button': {
            marginTop: 'auto',
        },
    },
    contentCardMinimized: {
        height: '70%',
        width: 'fit-content',
        background: '#fff',
        borderRadius: '12px',
        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
        marginTop: '24px',
        display: 'flex',
        flexDirection: 'column',
        paddingTop: '18px',
        '& button': {
            display: 'block',
            width: 'auto',
            height: '30px',
            margin: '10px 10px 24px 10px',
        },
        '& #expand-ai-assist-panel-button': {
            marginTop: 'auto',
            marginBottom: '10px',
            transform: 'rotate(180deg)',
        },
        '& img': {
            width: 'auto',
            height: '30px',
        },
    },
    queryInput: {
        marginBottom: '40px',
        backgroundColor: '#f4f6f6',
        '& .MuiInputBase-root': {
            fontFamily: 'FredokaRegular',
            fontWeight: 400,
            fontSize: '15.03px',
            color: '#74928e',
        },
        '& .MuiOutlinedInput-notchedOutline': {
            borderColor: '#8ba4a1',
        },
        '& .Mui-disabled': {
            color: '#8ba4a1',
            backgroundColor: '#fff',
        },
    },

    assistStartButton: {
        backgroundColor: '#456D69',
        color: 'white',
        border: 'none',
        borderRadius: '100px',
        padding: '12px 24px',
        fontSize: '14px',
        fontWeight: 500,
        fontFamily: 'FredokaRegular',
        textTransform: 'none',
        '&:hover': {
            backgroundColor: '#456D69',
        },
        marginTop: '32px',
        letterSpacing: '1.5px',
        lineHeight: '1.5',
    },

    helpMeButton: {
        backgroundColor: 'white',
        color: '#456D69',
        border: '1px solid #456D69',
        borderRadius: '100px',
        width: '100%',
        padding: '12px 24px',
        fontSize: '14px',
        fontWeight: 500,
        fontFamily: 'FredokaRegular',
        textTransform: 'none',
        '&:hover': {
            backgroundColor: '#f8f9ff',
        },
        '&:disabled': {
            border: '1px solid #e0e0e0',
        },
        marginBottom: '32px',
        letterSpacing: '1.5px',
        lineHeight: '1.5',
    },

    resetButton: {
        color: '#456D69',
    },

    sectionTitle: {
        fontSize: '24px',
        fontWeight: 700,
        color: '#456D69',
        marginBottom: '24px',
        fontFamily: 'Lora',
    },

    sectionDescriptionInactive: {
        fontSize: '18px',
        color: '#456D69',
        maxWidth: '400px',
        lineHeight: '1.5',
        fontFamily: 'FredokaRegular',
        opacity: 0.5,
    },

    sectionDescriptionActive: {
        fontSize: '18px',
        color: '#456D69',
        maxWidth: '400px',
        lineHeight: '1.5',
        fontFamily: 'FredokaRegular',
    },

    initialResponse: {
        fontSize: '18px',
        color: '#456D69',
        maxWidth: '400px',
        lineHeight: '1.2',
        fontFamily: 'FredokaRegular',
    },

    chatHistory: {
        fontSize: '16px',
        color: '#456D69',
        maxWidth: '400px',
        lineHeight: '1.5',
        fontFamily: 'FredokaRegular',
    },

    thumbsIcon: {
        fontSize: '16px',
        cursor: 'pointer',
        color: '#456D69',
    },

    chatContainer: {
        maxHeight: '350px',
        overflowY: 'scroll',
    },

    prePromptContainer: {
        maxHeight: '450px',
        overflow: 'auto',
    },

    userMessageBubble: {
        backgroundColor: '#fbfffa',
        borderRadius: '4px',
        padding: '10px 15px',
        margin: '5px 0',
        width: 'fit-content',
        maxWidth: '80%',
        marginLeft: 'auto',
        position: 'relative',
    },

    aiMessageBubble: {
        backgroundColor: '#f5f5f5',
        borderRadius: '4px',
        padding: '10px 15px 30px 15px',
        margin: '5px 0',
        maxWidth: '95%',
        marginRight: 'auto',
        position: 'relative',
    },

    initialResponseFeedbackContainer: {display: 'flex', justifyContent: 'flex-end', marginTop: '18px'},

    feedbackContainer: {
        position: 'absolute',
        bottom: '5px',
        right: '10px',
        display: 'flex',
        gap: '8px',
    },
    linearProgressRedBar: {
        width: '60%',
        height: '1px',
        backgroundColor: '#fff',
        '& .MuiLinearProgress-barColorPrimary': {
            backgroundColor: '#8ba4a1',
        },
    },
    htmlContent: {
        '& a': {
            textDecoration: 'underline',
        },
    },
    markdownFormatting,
    markdownFormattingExtended,
    markdownFormattingExtendedH3: {
        ...markdownFormattingExtended,
        fontSize: '20px',
        fontWeight: 700,
    },
}));
